<template>
  <b-modal size="lg" id="modalSaleSquareMeder" hide-header>
    <template #modal-footer>
      <div style="display: flex; justify-content: space-between; width: 100%">
        <div>
          <button class="btnsSale" @click="closeModal">Voltar</button>
        </div>
        <!-- <div>
            <button class="btnsSale" @click="print">Imprimir</button>
          </div> -->
        <div>
          <button
            class="btnsSale btnConfirm"
            @click="saveOrUpdateSale(true)"
            :disabled="loadingToSaveOrUpdate"
          >
            <p style="margin: 0; position: relative">
              Salvar

              <b-spinner
                v-if="loadingToSaveOrUpdate"
                style="
                  width: 15px;
                  height: 15px;
                  color: gray;
                  position: absolute;
                  right: 10px;
                  top: 10%;
                "
              />
            </p>
          </button>
        </div>
        <!-- <div>
            <button
              class="btnsSale btnsSaveOrSendNfe"
              @click="handleTranformToNfeAndCloseModal"
            >
              {{ returnTextSaveAndSendNota }}
            </button>
          </div> -->
      </div>
    </template>

    <div>
      <div class="headerSale">
        <p>
          {{
            dataSaleSquareMeter.status === salesSquareMeterType.venda
              ? "Venda"
              : "Orçamento"
          }}
          {{ numberSale || dataSaleSquareMeter.numero }}
        </p>
        <p>{{ totals.total }}</p>
      </div>

      <div style="padding: 0 10px">
        <hr style="margin-top: 0.2rem; margin-bottom: 1rem" />
      </div>
      <div @click="closeModal" class="closeModal">
        <b-icon-x scale="1.3"></b-icon-x>
      </div>
    </div>

    <div class="contentSections">
      <section class="dataCabecalho">
        <div class="contentItens" style="padding: 0 0 0 5px">
          <p class="titleItens">Cliente</p>
          <p class="itens">
            {{ squareMeterForModal.customerSelected.nome }}
          </p>
        </div>

        <div class="contentItens" style="align-items: center">
          <p class="titleItens">Data da Venda</p>
          <p class="itens">
            {{ squareMeterForModal.data | moment }}
          </p>
        </div>

        <div class="contentItens" style="align-items: flex-end">
          <p class="titleItens">Funcionário</p>
          <p class="itens">
            {{ squareMeterForModal.employeeSelected.nomeFuncionario }}
          </p>
        </div>
      </section>

      <section class="dataSaleItems responsiveTable">
        <table>
          <thead>
            <tr>
              <th>Produto/Serviço</th>
              <th style="text-align: start">Alt</th>
              <th style="text-align: start">Larg</th>
              <th style="text-align: start">Qnt.</th>
              <th style="text-align: start">MT²</th>
              <th style="text-align: center">Valor</th>
              <th style="text-align: end">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(
                product, indice
              ) in squareMeterForModal.formattedProductsSale"
              :key="indice"
            >
              <td>
                <div style="display: flex; flex-direction: column">
                  <p style="margin: 0">
                    {{ product.nome }}
                  </p>

                  <p
                    style="
                      margin: 0;
                      color: gray;
                      font-size: 11px;
                      font-style: italic;
                    "
                  >
                    {{ product.dadosAdicionais }}
                  </p>
                </div>
              </td>
              <td>{{ product.altura }}</td>
              <td>{{ product.largura }}</td>
              <td style="text-align: start">{{ product.quantidade }}</td>
              <td style="text-align: start">
                {{ maskAmount(product.metragem) }}
              </td>
              <td style="text-align: center">R$ {{ product.valorUnitario }}</td>
              <td style="text-align: end">
                {{ maskCurrency(product.valorTotal) }}
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <b-row style="margin: 30px 0">
        <div class="contentDataTotals">
          <div class="contentTotals">
            <span class="boxTotals">
              <p>Subtotal (R$)</p>
              <p class="colorItens">{{ totals.totalItems }}</p>
            </span>

            <span class="boxTotals">
              <p>Desconto (R$)</p>
              <p class="colorItens">{{ totals.totalDiscount }}</p>
            </span>

            <span class="dashed"></span>

            <span class="boxTotals contentFreteTotals">
              <p>Frete (R$)</p>
              <p class="frete">{{ totals.additionalValues }}</p>
            </span>

            <span class="boxTotals contentFreteTotals">
              <p>Outros (R$)</p>
              <p class="frete">{{ totals.otherValues }}</p>
            </span>

            <span class="boxTotals totals">
              <p>Total da Venda (R$)</p>
              <p class="colorItens">{{ totals.total }}</p>
            </span>
          </div>
        </div>
      </b-row>

      <hr style="margin: 0" v-if="dataSaleSquareMeter.bills.length" />
      <div class="generalContent" v-if="dataSaleSquareMeter.bills.length">
        <div class="subTitle">
          <p>Informações Financeiras</p>
        </div>

        <div class="contentTitlesFinancial">
          <div>
            <p class="titleFinancial">Forma de Pagamento</p>
            <p class="subTitleFinancial">{{ paymentsDataInfo.typePayment }}</p>
          </div>

          <div v-if="!isSimpleSafe">
            <p class="titleFinancial">Conta de Recebimento</p>
            <p class="subTitleFinancial">
              {{ paymentsDataInfo.receiptAccount }}
            </p>
          </div>

          <div>
            <p class="titleFinancial">Intervalo de Parcelas (dias)</p>
            <p class="subTitleFinancial">
              {{ paymentsDataInfo.installmentsInterval }}
            </p>
          </div>

          <div>
            <p class="titleFinancial">Número de Parcelas</p>
            <p class="subTitleFinancial">
              {{ paymentsDataInfo.installmentsNumber }}
            </p>
          </div>

          <div>
            <p class="titleFinancial">Venc. Primeira Parcela</p>
            <p class="subTitleFinancial">{{ paymentsDataInfo.expiredFirst }}</p>
          </div>
        </div>
      </div>

      <div class="generalContent mt-3" v-if="dataSaleSquareMeter.bills.length">
        <div class="subTitle">
          <p>Parcelas</p>
        </div>

        <div
          style="
            background-color: whitesmoke;
            padding: 10px 5px;
            border-radius: 5px;
          "
        >
          <table style="text-align: center">
            <thead>
              <tr>
                <th style="width: 60px"></th>
                <th style="width: 150px">Data de vencimento</th>
                <th>Valor restante</th>
                <th>Valor pago</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(bill, index) in dataSaleSquareMeter.bills"
                :key="index"
              >
                <td>{{ index + 1 }}º Venc.</td>
                <td>
                  {{ bill.data.split(" ")[0].split("-").reverse().join("/") }}
                </td>
                <td>
                  {{
                    bill.dataPagamento
                      ? maskCurrency(0)
                      : maskCurrency(bill.valorRestante)
                  }}
                </td>
                <td>
                  {{
                    bill.dataPagamento && !bill.valorPago
                      ? maskCurrency(bill.valorRestante)
                      : maskCurrency(bill.valorPago)
                  }}
                </td>
                <td>{{ bill.descricao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <hr style="margin: 20px 0" v-if="dataSaleSquareMeter.dadosAdicionais" />

      <div class="generalContent m-0">
        <div v-if="dataSaleSquareMeter.dadosAdicionais != ''">
          <p class="titleObs">Observações Gerais</p>
          <div class="descriptions">
            {{ dataSaleSquareMeter.dadosAdicionais }}
          </div>
        </div>

        <div v-if="dataSaleSquareMeter.observacoesNf != ''">
          <p class="titleObs">Observação de Nota Fiscal</p>
          <div class="descriptions">
            {{ dataSaleSquareMeter.observacoesNf }}
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-center-sale-squared"
      hide-footer
      hide-header
      centered
      title="Emitir"
      @hidden="closePrint"
      size="lg"
    >
      <div>
        <h6 class="titleModal">
          {{ !isOtherPrints ? "Deseja imprimir ?" : "Modelos para impressão" }}
        </h6>
        <div class="btnModal" v-if="!isOtherPrints">
          <button class="btnContentReceive" @click="showOtherPrints">
            Impressões
          </button>
          <button
            v-if="
              (isStoneIntegration || isVeroIntegration) && enableReceivePayment
            "
            class="btnContent"
            style="display: flex; justify-content: center; align-items: center"
            @click="openModals('modalSelectMachine2')"
            :disabled="isGenerateOrder"
          >
            Receber Pagamento

            <b-spinner v-if="isGenerateOrder" class="spinnerCreateOrder" />
          </button>
          <button
            class="btnContent"
            @click="handleTranformToNfeAndCloseModal"
            v-if="dataSaleSquareMeter.status === salesSquareMeterType.venda"
          >
            {{ returnTextSaveAndSendNota }}
          </button>
          <button
            class="btnContent"
            @click="handleValidateDataAndGenerateSaleSquareMeter"
            v-else
          >
            Transformar em Venda MT2
          </button>
        </div>

        <div class="rowContainer" v-else>
          <span>
            <b-icon-calendar-week></b-icon-calendar-week> Selecione um
            modelo:</span
          >
          <div class="rowContent mt-3">
            <div
              class="containerRadio"
              v-for="(modelPrint, idx) in modelsPrints"
              :key="idx"
            >
              <label
                @click="selectTypeReport(modelPrint.type)"
                style="width: 130px !important"
              >
                <input
                  type="radio"
                  name="radio"
                  :checked="typeReportSelected === modelPrint.type"
                />
                <span>{{ modelPrint.text }}</span>
              </label>
            </div>
          </div>

          <label
            v-if="[
              E_TypesReports.simple,
              E_TypesReports.duasVias,
              E_TypesReports.rooms,
            ].includes(typeReportSelected)"
            class="optionUnitPrint"
          >
            <input type="checkbox" v-model="showProductUnit" />
            Exibir unidade do produto na coluna Tipo
          </label>

          <div class="rowContent" style="justify-content: flex-end; padding: 0">
            <button class="btnPrint" @click="printReportSelect">
              Imprimir
            </button>
          </div>
        </div>

        <div v-if="isOtherPrints" class="rowContent mt-3" style="padding: 0">
          <span class="contentClosePrint" @click="closePrint">
            <b-icon-arrow-left scale="1.5" />
            <p>Voltar</p>
          </span>
        </div>

        <a
          class="rejectModal"
          v-if="!spinLoading && !isOtherPrints"
          @click="startNewSaleSquareMeter"
        >
          Não, Obrigado! Iniciar
          {{
            dataSaleSquareMeter.status === salesSquareMeterType.venda
              ? "nova venda"
              : "novo orçamento"
          }}</a
        >
      </div>
      <Loading v-if="spinLoading" class="spin" />
    </b-modal>
    <ModalAwaitPayment
      :idSale="dataSaleSquareMeter.id"
      :typeSale="typeSale.vendaMtq"
      :typeIntegration="typeIntegration"
      @cancelPayment="closeModal('ModalAwaitPayment')"
    />

    <b-modal
      id="modalSelectMachine2"
      size="sm"
      hide-footer
      hide-header
      centered
      title="Emitir"
    >
      <div>
        <h6 class="titleModalSelectMachine">Selecione a maquininha</h6>
        <div class="contentModalSelectMachine">
          <div style="width: 100%">
            <InputSelect
              label="Maquininhas"
              valueField="value"
              textField="text"
              :items="machineTypes"
              :dataSelect.sync="typeIntegration"
              :dataInput="typeIntegration"
              :enableIconCreate="false"
              ref="machines"
            />
          </div>

          <div
            style="
              display: flex;
              gap: 0.5rem;
              width: 100%;
              justify-content: center;
            "
          >
            <div class="btn-container">
              <b-icon-file-earmark-text />
              <label class="switch btn-color-mode-switch">
                <input
                  value="1"
                  id="color_mode"
                  name="color_mode"
                  type="checkbox"
                  v-model="isNfe"
                />
                <label
                  class="btn-color-mode-switch-inner"
                  data-off="NFC-e"
                  data-on="NF-e"
                  for="color_mode"
                ></label>
              </label>
              <b-icon-receipt />
            </div>
          </div>
          <div
            style="
              display: flex;
              gap: 0.5rem;
              width: 100%;
              justify-content: center;
            "
          >
            <span style="color: red; font-size: 11px">
              <b-icon-exclamation-triangle /> Após o pagamento será emitido uma
              <strong style="color: blue; font-size: 12px">{{
                isNfe ? "NF-e" : "NFC-e"
              }}</strong>
            </span>
          </div>

          <div style="display: flex; gap: 0.5rem; width: 100%">
            <button
              class="btnCloseModalMachine"
              @click="closeModal('modalSelectMachine2')"
            >
              Voltar
            </button>

            <button class="btnConfirmMachine" @click="generateOrderInMachine">
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import moment from "moment";

import Loading from "../Loading/Loading.vue";
import ModalAwaitPayment from "../Modals/ModalAwaitPayment.vue";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";

import ServiceSaleSquareMeter from "../../services/serviceSaleSquareMeter";
import ServiceSituation from "../../services/serviceSituation";
import ServiceMachine from "../../services/serviceMachine";
import { OrderMachineStatus } from "../../utils/enums/OrderMachineState";

import { ValidadeSquareMeterBudget } from "../../validators/squareMeterBudget";
import { HandleErrors } from "../../utils/handleErrors";
import { TypeErrors } from "../../utils/enums/TypeErrors";
import toastAlertErros from "../../utils/toastAlertErros";
import { maskAmount } from "../../utils/maskMoney";
import { SalesSquareMeterType } from "../../utils/enums/SalesSquareMeterType";
import { SquareMeterSituationType } from "../../utils/enums/SquareMeterSituationType";
import { E_TypesReports } from "../../utils/enums/reports/SaleSquareMeter";
import { formatObjectToSaveAndUpdate } from "../../helpers/squareMeterSaleAndBudget";
import { TypeSale } from "../../utils/enums/SalesType";

import DefaultLogo from "../../assets/LogoTeste.jpeg";
import print from "../../reports/saleSquareMeter";

export default {
  components: {
    Loading,
    ModalAwaitPayment,
    InputSelect,
  },
  props: {
    dataSaleSquareMeter: {
      type: Object,
    },
    totals: {
      type: Object,
    },
    squareMeterForModal: {
      type: Object,
    },
    paymentsDataInfo: {
      type: Object,
    },
    numberSale: {
      type: [Number, String],
    },
  },
  data() {
    return {
      spinLoading: false,
      defaultLogo: DefaultLogo,
      productsSale: {},
      maskAmount: maskAmount,
      salesSquareMeterType: SalesSquareMeterType,
      E_TypesReports,
      isOtherPrints: false,
      modelPrintDefault: "1",
      typeReportSelected: E_TypesReports.simple,
      showProductUnit: false,
      modelsPrints: [
        { text: "Padrão", value: true, type: E_TypesReports.simple },
        {
          text: "Padrão duas vias",
          value: false,
          type: E_TypesReports.duasVias,
        },
        {
          text: "Por Ambiente",
          value: false,
          type: E_TypesReports.rooms,
        },
        {
          text: "romaneio",
          value: false,
          type: E_TypesReports.deliveryManifest,
        },
        {
          text: "Contrato",
          value: false,
          type: "contractEditable",
        },
      ],
      typeSale: TypeSale,
      loadingToSaveOrUpdate: false,
      enableReceivePayment: true,
      typeIntegration: "stone",
      isGenerateOrder: false,
      machineTypes: [
        { text: "Stone", value: "stone" },
        { text: "Vero", value: "vero" },
      ],
      isNfe: false,
    };
  },
  methods: {
    ...mapMutations([
      "SET_DATA_NFE",
      "ALTER_VALUES_MODAL_DIALOG_GENERAL",
      "ALTER_TYPE_DOCUMENT",
      "SET_SALE_INTERVAL_MACHINE_ID",
    ]),
    async saveOrUpdateSale(showToast) {
      if (!this.dataSaleSquareMeter.id) return await this.saveSale(showToast);
      await this.updateCompleted(showToast);
    },

    async saveSale(showToast = true) {
      try {
        this.loadingToSaveOrUpdate = true;
        const dataSaleFormatted = formatObjectToSaveAndUpdate(
          this.dataSaleSquareMeter
        );

        await ServiceSaleSquareMeter.createWithoutProduct(dataSaleFormatted);

        this.openModals("modal-center-sale-squared");

        if (showToast) {
          return this.$toast.open({
            message: `${
              this.dataSaleSquareMeter.status === "Orçamento"
                ? "Orçamento salvo com Sucesso"
                : "Venda salva com Sucesso"
            }`,
            type: "success",
          });
        }
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (!this.dataConfig.caixa_automatico.utilizar) {
          if (
            typeError &&
            Object.keys(typeError).length &&
            TypeErrors.NO_SAFE_REGISTER_OPEN.includes(typeError?.nameError)
          ) {
            return this.handleModalSafeOpening();
          }
        }

        if (error.response.status === 422) {
          return this.$toast.open({
            message:
              typeError?.message ||
              "Verifique se os dados do cliente foram informados",
            type: "info",
          });
        } else {
          return this.$toast.open({
            message:
              error?.response?.data?.message ||
              "Verifique se os dados do cliente foram informados",
            type: "info",
          });
        }
      } finally {
        this.loadingToSaveOrUpdate = false;
      }
    },

    async updateCompleted(showToast = true) {
      try {
        this.loadingToSaveOrUpdate = true;
        const dataSaleFormatted = formatObjectToSaveAndUpdate(
          this.dataSaleSquareMeter
        );

        await ServiceSaleSquareMeter.updateWithoutProduct(dataSaleFormatted);

        this.openModals("modal-center-sale-squared");

        if (showToast) {
          return this.$toast.open({
            message: `${
              this.dataSaleSquareMeter.status === "Orçamento"
                ? "Orçamento salvo com Sucesso"
                : "Venda salva com Sucesso"
            }`,
            type: "success",
          });
        }
      } catch (error) {
        console.log(error);
        const typeError = HandleErrors(error?.response?.data?.message);

        if (!this.dataConfig.caixa_automatico.utilizar) {
          if (
            typeError &&
            Object.keys(typeError).length &&
            TypeErrors.NO_SAFE_REGISTER_OPEN.includes(typeError?.nameError)
          ) {
            return this.handleModalSafeOpening();
          }
        }

        if (showToast) {
          return this.$toast.open({
            message:
              typeError?.message ||
              error.response.data.message ||
              "Verifique se os dados do cliente foram informados",
            type: "info",
          });
        }
      } finally {
        this.loadingToSaveOrUpdate = false;
        this.openModals("modal-center-sale-squared");
      }
    },

    printReportSelect() {
      if (!this.dataSaleSquareMeter.id) return;
      print(
        this.typeReportSelected,
        this.dataSaleSquareMeter.id,
        this.showProductUnit
      );
    },

    showOtherPrints() {
      this.isOtherPrints = !this.isOtherPrints;
    },

    async handleTranformToNfeAndCloseModal() {
      const showToast = false;
      if (!this.dataSaleSquareMeter.id) await this.saveSale(showToast);

      this.closeModal();
      this.transformToNfe();
    },

    async transformToNfe() {
      try {
        const dataNFe = await ServiceSaleSquareMeter.transformWithNota(
          this.dataSaleSquareMeter.id
        );

        this.SET_DATA_NFE(dataNFe);
        this.$toast.open({
          message: "Venda transformada em nota fiscal!",
          type: "success",
        });

        this.$router.push({
          path: `/fiscal`,
        });
      } catch (error) {
        if (error?.response?.data?.erros)
          return this.$toast.open({
            message:
              error?.response?.data?.erros ||
              "Ocorreu um problema ao transformar a venda MT2 em NF-e",
            type: "info",
          });

        return toastAlertErros.validateMessage(error, this.$toast);
      }
    },

    async handleValidateDataAndGenerateSaleSquareMeter() {
      const situation = await ServiceSituation.findById(
        this.dataSaleSquareMeter.idSituacao
      );

      if (situation.nome === SquareMeterSituationType.cancelado) {
        return this.$toast.open({
          message:
            "Não é possível gerar uma venda a partir de um orçamento cancelado",
          type: "info",
        });
      }

      const isNotValid = ValidadeSquareMeterBudget(this.dataSaleSquareMeter);
      if (isNotValid) {
        return this.$toast.open({
          message: isNotValid,
          type: "info",
        });
      }

      await this.generateSaleSquareMeter(this.dataSaleSquareMeter.id);
    },

    async generateSaleSquareMeter(id) {
      try {
        const result =
          await ServiceSaleSquareMeter.transforBudgetToSaleSquareMeter(id);

        this.$toast.open({
          message: "Venda gerada com sucesso!",
          type: "success",
        });

        this.handleTransformToSale(result);
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um problema ao gerar a venda!",
          type: "info",
        });
      }
    },

    handleTransformToSale() {
      this.$emit("transformToSale");
      this.dataSaleSquareMeter.status = "Venda";
      this.ALTER_TYPE_DOCUMENT("vendaMtq");
      this.$bvModal.hide("modal-center-sale-squared");
      this.closeModal();
    },

    maskCurrency(valor, locale = "pt-BR") {
      if (!valor) {
        valor = 0;
      }
      return parseFloat(valor).toLocaleString(locale, {
        style: "currency",
        currency: "BRL",
      });
    },

    handleModalSafeOpening() {
      this.ALTER_VALUES_MODAL_DIALOG_GENERAL({
        nameModal: "modalDialogSafeOpening",
        title: "Caixa ainda não aberto!",
        subTitle:
          "Verificamos que você ainda não iniciou o caixa, para realizar qualquer lançamento, é necessario realizar a abertura do caixa!",
        footerTitle: "Deseja abrir o caixa agora ?",
        leftButtonText: "Não",
        rightButtonText: "Sim",
      });

      this.$nextTick(() => {
        this.openModals(this.dataModalDialogGeneral.nameModal);
      });
    },

    selectTypeReport(typeReport) {
      this.typeReportSelected = typeReport;
    },

    closePrint() {
      this.isOtherPrints = false;
      this.typeReportSelected = E_TypesReports.simple;
      this.showProductUnit = false;
    },

    openModals(name) {
      this.$bvModal.show(name);
    },

    closeModal() {
      this.$bvModal.hide("modalSaleSquareMeder");
    },

    startNewSaleSquareMeter() {
      this.$emit("clearAllSaleSquareMeter");
      this.$bvModal.hide("modal-center-sale-squared");
      this.closeModal();
    },
    async generateOrderInMachine() {
      try {
        this.$bvModal.hide("modalSelectMachine2");
        this.isGenerateOrder = true;

        if (!this.dataSaleSquareMeter.bills.length) {
          return this.$toast.open({
            message: "Nenhum pagamento informado",
            type: "info",
          });
        }

        await ServiceMachine.createOrder(
          this.dataSaleSquareMeter.id,
          this.typeIntegration,
          "mtq"
        );

        this.startPaymentInMachine();
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao criar a ordem para a maquininha",
          type: "info",
        });
      } finally {
        this.isGenerateOrder = false;
      }
    },

    async startPaymentInMachine() {
      this.$bvModal.show("ModalAwaitPayment");

      const id = setInterval(this.checkPaymentIsFinished, 5000);
      this.SET_SALE_INTERVAL_MACHINE_ID(id);
    },

    async checkPaymentIsFinished(
      toastMessag = "Pagamento realizado com sucesso!",
      repeatToast = false
    ) {
      try {
        this.spinLoading = true;
        let result;
        if (this.isNfe) {
          result = await ServiceMachine.checkIsPaidAndGenerateDocumentNfe(
            this.dataSaleSquareMeter.id,
            this.typeIntegration,
            "mtq"
          );
        } else {
          result = await ServiceMachine.checkIsPaidAndGenerateDocument(
            this.dataSaleSquareMeter.id,
            this.typeIntegration,
            "mtq"
          );
        }
        if (result?.status === OrderMachineStatus.PAID) {
          clearInterval(this.saleIntervalMachineId);
          this.SET_SALE_INTERVAL_MACHINE_ID("");

          this.$bvModal.hide("ModalAwaitPayment");
          this.enableReceivePayment = false;

          if (repeatToast) {
            this.$toast.open({
              message: toastMessag,
              type: "success",
            });
          }

          if (!repeatToast && !this.isShowToastConfirmPayment) {
            this.$toast.open({
              message: toastMessag,
              type: "success",
            });
          }

          this.isShowToastConfirmPayment = true;
        }

        if (result.status === OrderMachineStatus.CANCELED) {
          clearInterval(this.saleIntervalMachineId);
          this.SET_SALE_INTERVAL_MACHINE_ID("");
          this.enableReceivePayment = true;
          this.$bvModal.hide("ModalAwaitPayment");
        }
      } catch (error) {
        clearInterval(this.saleIntervalMachineId);
        this.SET_SALE_INTERVAL_MACHINE_ID("");
        this.$bvModal.hide("ModalAwaitPayment");

        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        if (repeatToast) {
          this.$toast.open({
            message: "Ocorreu um problema com a emissão do Cupom fiscal",
            type: "info",
          });
        } else if (
          typeError &&
          typeError?.nameError === TypeErrors.ITEM_NF_INVALID
        ) {
          this.enableReceivePayment = false;

          this.$toast.open({
            message: `Pagamento realizado, porém ocorreu um erro com emissão do documento fiscal. 
              <br />  
              <div style="color: yellow!important">ERRO: ${typeError.message}</div>
            `,
            type: "info",
          });
        } else {
          this.$toast.open({
            message:
              typeError?.message ||
              "Ocorreu um problema ao efetuar o pagamento!",
            type: "info",
          });
        }
      } finally {
        this.spinLoading = false;
      }
    },

    async checkPaymentIsPending(id) {
      try {
        const { status, machine } = await ServiceMachine.checkOrder(id, "mtq");

        if (status === OrderMachineStatus.PENDING && machine) {
          this.startPaymentInMachine();
        } else if (status === OrderMachineStatus.CANCELED) {
          this.enableReceivePayment = true;
        } else if (status === OrderMachineStatus.PAID) {
          this.enableReceivePayment = false;
        }
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um problema ao efetuar o pagamento!",
          type: "info",
        });
      }
    },
  },
  computed: {
    ...mapState({
      dataCompany: (state) => state.dataCompany,
      dataModalDialogGeneral: (state) => state.dataModalDialogGeneral,
      dataSafeIsOpen: (state) => state.dataSafeIsOpen,
      dataConfig: (state) => state.dataConfig,
      productionOrderSaleSquareMeterId: (state) =>
        state.productionOrderSaleSquareMeterId,
      saleIntervalMachineId: (state) => state.saleIntervalMachineId,
    }),
    returnTextSaveAndSendNota() {
      if (!this.dataSaleSquareMeter.id) {
        return "Salvar e Emitir NF-e";
      } else {
        return "Emitir NF-e";
      }
    },
    safeIsOpen() {
      return this.dataSafeIsOpen.safeIsOpen;
    },
    isSimpleSafe() {
      return this.dataConfig?.caixa_simples ?? true;
    },
    isStoneIntegration() {
      if (
        this.dataCompany?.liberars[0]?.integracoes &&
        Object.keys(this.dataCompany?.liberars[0]?.integracoes).length
      ) {
        const stone =
          this.dataCompany?.liberars[0]?.integracoes.cardMachines.find(
            (machine) => machine.text === "STONE"
          );

        return stone.value;
      }

      return false;
    },
    isVeroIntegration() {
      if (
        this.dataCompany?.liberars[0]?.integracoes &&
        Object.keys(this.dataCompany?.liberars[0]?.integracoes).length
      ) {
        const vero =
          this.dataCompany?.liberars[0]?.integracoes.cardMachines.find(
            (machine) => machine.text === "VERO"
          );

        return vero ? vero.value : false;
      }

      return false;
    },
  },
  watch: {
    safeIsOpen() {
      this.saveOrUpdateSale();
    },
  },
  filters: {
    moment(data) {
      return moment(data).format("DD/MM/YYYY");
    },
  },
  beforeDestroy() {
    this.typeIntegration = "stone";
  },
  mounted() {
    if (
      this.productionOrderSaleSquareMeterId &&
      (this.isStoneIntegration || this.isVeroIntegration)
    ) {
      this.checkPaymentIsPending(this.productionOrderSaleSquareMeterId);
    }
  },
};
</script>

<style scoped>
.footerBtn {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

thead th {
  border-bottom: 1px solid #d5d3d3;
  color: #afadad;
  font-size: 12px;
  font-weight: normal;
}

td {
  color: black;
  font-size: 12px;
}

.dataSaleItems {
  font-size: 14px;
  margin-top: 25px;
}

table {
  border-collapse: separate;
  border-spacing: 0 4px;
  width: 100%;
}

.responsiveTable {
  max-height: 200px;
  overflow-x: auto;
}

.btnsActions {
  width: 150px;
  font-size: 18px;
  margin-top: 0;
  background-color: #0fbf4d;
}

.btnSaveAndSendLeaf {
  width: 200px;
  font-size: 18px;
  margin-top: 0;
  background-color: #00395d;
}

.summaryTitle h5 {
  font-family: Arial, Helvetica, sans-serif;

  color: #00486e;
}

.contentSummary {
  display: flex;
  flex-direction: column;
}

.contentSummary p {
  margin-bottom: 5px;
}

.itensSummary {
  display: flex;
  justify-content: space-between;
}

.company p {
  font-family: Arial, Helvetica, sans-serif;
  color: #00486e;
  font-size: 15px;
}

.contentDataCompany {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dataCompany {
  display: flex;
  align-items: center;
  gap: 20px;
}

.dataCompany img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: solid 1px rgb(162, 144, 144);
}

.contentLogo {
  display: flex;
  justify-content: center;
}

.contentTotals {
  width: 370px;
  display: flex;
  flex-direction: column;
  text-align: right;
  align-items: flex-end;
  font-size: 14px;
  gap: 5px;
}

.boxTotals {
  display: flex;
  align-items: center;
  gap: 30px;
  color: #666360;
}

.dashed {
  border-bottom: 1px dashed #b1aaa5;
  width: 100%;
  margin: 10px 0;
  cursor: auto;
}

.boxTotals {
  display: flex;
  align-items: center;
  cursor: auto;
}

.boxTotals .colorItens {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  outline: none;
  padding-right: 5px;
  background-color: #f2f3f3;
  border-radius: 5px;
  height: 30px;
  width: 177px;
}

.totals {
  font-size: 13px !important;
  color: #666360 !important;
  font-weight: 600;
}

.contentFreteTotals .frete {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  outline: none;
  padding-right: 5px;
  background-color: #f2f3f3;
  border-radius: 5px;
  height: 30px;
  width: 177px;
}

.dataCabecalho {
  width: 100%;
  display: flex;
  background-color: #f7f7f7;
  gap: 20px;
  border-radius: 4px;
}

.contentItens {
  display: flex;
  flex-direction: column;
  width: 30%;
}

.titleItens {
  color: #afadad;
  font-size: 12px;
}

.itens {
  color: black;
  font-size: 14px;
}

.contentSections {
  display: flex;
  flex-direction: column;
  padding: 0 10px;
}

.titleModal {
  font-size: 12px;
  border-bottom: 1px solid #e6e7e8;
}

.btnModal {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 50px;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 30%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #00486e;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 30%;
  height: 28px;
  position: relative;
  color: #00486e;
  background: white;
}

.btnPrint {
  font-size: 11px;
  border: 1px solid #0fbf4d;
  border-radius: 3px;
  color: #ffffff;
  background: #0fbf4d;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.185);
  transition: ease-in all 0.1s;
}

.btnPrint:hover {
  transition: ease-in all 0.1s;
  background: #0ea241;
}

.contentClosePrint {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.3rem;
  font-size: 11px;
  border-radius: 3px;
  color: #00486e;
  transition: ease-in all 0.1s;
  font-weight: 600;
  cursor: pointer;
}

.contentClosePrint:hover {
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.321);
}

.titleModalSelectMachine {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  border-bottom: 1px solid #e6e7e8;
}

.contentModalSelectMachine {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  gap: 1.3rem;
  height: auto;
  margin-top: 1.3rem;
}

.btnConfirmMachine {
  font-size: 11px;
  border: 1px solid #0fbf4d;
  border-radius: 3px;
  width: 100%;
  height: 28px;
  position: relative;
  background-color: #0fbf4d;
  color: white;
  background-color: #0fbf4d;
  transition: ease-in 0.1s;
}

.btnConfirmMachine:hover {
  background-color: #0c963c;
  transition: ease-in 0.1s;
}

.btnCloseModalMachine {
  font-size: 11px;
  border: 1px solid black;
  border-radius: 3px;
  width: 100%;
  height: 28px;
  position: relative;
  background-color: white;
  color: black;
  background-color: white;
  transition: ease-in 0.1s;
}

.btnCloseModalMachine:hover {
  background-color: rgb(233, 233, 233);
  transition: ease-in 0.1s;
}

.rejectModal {
  cursor: pointer;
  color: black;
  display: flex;
  justify-content: center;
  font-size: 11px;
  font-style: oblique;
  text-decoration: underline;
}

.btn-container {
  display: flex;
  vertical-align: middle;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.btn-container i {
  display: inline-block;
  position: relative;
  top: -9px;
}

label {
  font-size: 13px;
  color: #424242;
  font-weight: 500;
}

.btn-color-mode-switch {
  display: inline-block;
  margin: 0px;
  position: relative;
}

.btn-color-mode-switch > label.btn-color-mode-switch-inner {
  margin: 0px;
  width: 140px;
  height: 30px;
  background: #e0e0e0;
  border-radius: 26px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
  display: block;
}

.btn-color-mode-switch > label.btn-color-mode-switch-inner:before {
  content: attr(data-on);
  position: absolute;
  font-size: 12px;
  font-weight: 500;
  top: 7px;
  right: 20px;
}

.btn-color-mode-switch > label.btn-color-mode-switch-inner:after {
  content: attr(data-off);
  width: 70px;
  height: 26px;
  background: #fff;
  border-radius: 26px;
  position: absolute;
  left: 2px;
  top: 2px;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0px 0px 6px -2px #111;
  padding: 5px 0px;
}

.btn-color-mode-switch > .alert {
  display: none;
  background: #ff9800;
  border: none;
  color: #fff;
}

.btn-color-mode-switch input[type="checkbox"] {
  cursor: pointer;
  width: 50px;
  height: 25px;
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 1;
  margin: 0px;
}

.btn-color-mode-switch
  input[type="checkbox"]:checked
  + label.btn-color-mode-switch-inner {
  background: #acacac;
}

.btn-color-mode-switch
  input[type="checkbox"]:checked
  + label.btn-color-mode-switch-inner:after {
  content: attr(data-on);
  left: 68px;
  background: #3c3c3c;
  color: white;
}

.btn-color-mode-switch
  input[type="checkbox"]:checked
  + label.btn-color-mode-switch-inner:before {
  content: attr(data-off);
  right: auto;
  left: 20px;
}

.btn-color-mode-switch input[type="checkbox"]:checked ~ .alert {
  display: block;
}

.dark-preview {
  background: #0d0d0d;
}

.white-preview {
  background: #fff;
}

.spin {
  width: 480px;
  height: 100%;
  top: 0;
}

.headerSale {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px 0 10px;
}

.headerSale p {
  font-size: 14px !important;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  color: #666360 !important;
}

.closeModal {
  position: absolute;
  top: 0;
  right: 0;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgba(245, 245, 245, 0.476);
  padding: 1px 2px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.contentDataTotals {
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.btnsSale {
  border-radius: 5px;
  background-color: transparent;
  width: 200px;
  height: 28px;
  border: none;
  border: solid 1px black;
  color: black;
  font-size: 12px;
}

.btnConfirm {
  background-color: whitesmoke;
  border: solid 1px #0fbf4d;
  color: #0fbf4d;
}

.btnsSaveOrSendNfe {
  width: 135px !important;
}

.titleObs {
  color: black;
}

.descriptions {
  outline: none;
  padding: 5px;
  background-color: #f2f3f3;
  border-radius: 5px;
  min-height: 30px;
  height: auto;
  width: 100%;
  font-size: 12px;
}

.generalContent {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
}

.generalContent p {
  font-size: 14px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

.contentFinancialObservations p {
  color: black;
  font-size: 14px;
}

.contentTitlesFinancial {
  width: 100%;
  display: flex;
  gap: 30px;
  text-align: center;
  margin: 10px 0;
  background-color: whitesmoke;
  padding: 10px 5px;
  border-radius: 5px;
}

.titleFinancial {
  color: #afadad !important;

  font-size: 12px !important;
}

.subTitleFinancial {
  font-size: 12px !important;
}

p {
  margin: 0 !important;
}

*::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: #00486e;
  border-radius: 2px;
}

.modal-footer {
  padding: 0.25rem;
}

.subTitle p {
  font-size: 14px;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-top: 20px;
}

.rowContainer span {
  font-weight: 600;
  font-size: 11px;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  gap: 10px;
}

.optionUnitPrint {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0 0;
  font-size: 12px;
  cursor: pointer;
}

/* INPUT RADIO */

.containerRadio label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
}

.containerRadio label input {
  position: absolute;
  left: -9999px;
}

.containerRadio label input:checked + span {
  background-color: #f3f2f2;
  color: rgb(0, 0, 0);
}

.containerRadio label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #00486e;
}

.containerRadio label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 2px;
  transition: 0.25s ease;
}

.containerRadio label span:hover {
  background-color: #e6e6e6;
  border-radius: 2px;
}

.containerRadio label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.1em #00486e;
}

/* INPUT RADIO */

@media (min-width: 768px) and (max-width: 1200px) {
  .contentTotals {
    width: 351px;
    font-size: 11px;
    gap: 0px;
  }
}
</style>
